function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.86032 6.20281C5.07647 5.84769 5.49763 5.73398 5.83505 5.92456L5.9113 5.97397L10.0145 8.99573L14.0861 5.98327C14.4085 5.74471 14.8374 5.815 15.084 6.13199L15.1376 6.20949C15.3545 6.56407 15.2906 7.03589 15.0024 7.30718L14.9319 7.36609L10.439 10.6913C10.2122 10.8592 9.92336 10.8782 9.68249 10.7481L9.59462 10.6924L5.06836 7.35889C4.72069 7.10284 4.62755 6.58525 4.86032 6.20281Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0606 3.33325H3.93935C2.68416 3.33325 1.66663 4.45254 1.66663 5.83325V14.1666C1.66663 15.5473 2.68416 16.6666 3.93935 16.6666H16.0606C17.3158 16.6666 18.3333 15.5473 18.3333 14.1666V5.83325C18.3333 4.45254 17.3158 3.33325 16.0606 3.33325ZM3.93873 4.99992H16.0599C16.4783 4.99992 16.8175 5.37301 16.8175 5.83325V14.1666C16.8175 14.6268 16.4783 14.9999 16.0599 14.9999H3.93873C3.52033 14.9999 3.18115 14.6268 3.18115 14.1666V5.83325C3.18115 5.37301 3.52033 4.99992 3.93873 4.99992Z",
  fill: "currentColor"
});

function SvgEmail2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.ed9e05a3.svg";
export { ForwardRef as ReactComponent };